import { Directive, OnInit, ElementRef, Renderer2 } from '@angular/core';

@Directive({
	selector: '[toggle-article]'
})
export class ToggleArticleDirective implements OnInit {

	button;
	article;
	isOpen: boolean = false;
	constructor(private _elRef: ElementRef, private renderer: Renderer2) { }

	ngOnInit() {
		this.button = this._elRef.nativeElement.querySelector('.toggle-info-mobile');
		this.article = this._elRef.nativeElement.querySelector('.carousel-article__content');
		this.button.addEventListener("click", (e) => {
			if(this.isOpen){
				this.closeElem();
			}
			else{
				this.openElem();
			}
		})
	}

	openElem(){
		this.isOpen = true;
		this.renderer.addClass(this.article, 'is-open');
		this.renderer.addClass(this.button, 'is-open');

	}
	closeElem(){
		this.isOpen = false;
		this.renderer.removeClass(this.article, 'is-open');
		this.renderer.removeClass(this.button, 'is-open');
	}

}
